export default __webpack_public_path__ + "static/media/img_cse.9f1e07e4.svg";